<template>
  <div class="header-actions-wrapper">
    <div class="additional-header-actions" v-if="additionalActions">
      <a class="btn btn-link py-0" href="#" @click="goBack"
        ><i class="fa-regular fa-arrow-left"></i> Zurück zum Dsagnet</a
      >
      |
      <button class="btn btn-link py-0" @click="() => $emit('fullscreen')">
        <i class="fa-regular fa-expand-wide"></i> Vollbild</button
      >|
      <button
        class="btn btn-link py-0"
        @click="headerExpanded = !headerExpanded"
      >
        <template v-if="headerExpanded">
          Navigation <fa icon="fa-regular fa-chevron-up" />
        </template>
        <template v-else>
          Navigation <fa icon="fa-regular fa-chevron-down" />
        </template>
      </button>
    </div>
    <div class="header-actions" :class="{ 'golden-master': isGoldenMaster }">
      <ul class="icon-menu"></ul>
      <ul>
        <li>
          <a target="_blank" href="https://dsag.de"
            ><i class="fa-regular fa-arrow-right"></i>DSAG.de</a
          >
        </li>
        <li>
          <a @click="logout()"
            ><i class="fa-regular fa-arrow-right"></i>Logout</a
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    additionalActions: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isGoldenMaster() {
      return process.env.VUE_APP_IS_GOLDEN_MASTER === "true";
    },
  },
  methods: {
    logout() {
      this.$logout();
    },
    goBack(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$router.push({ name: "home" });
    },
  },
  data() {
    return {
      headerExpanded: false,
    };
  },
  watch: {
    headerExpanded(val) {
      this.$emit("headerVisible", val);
    },
  },
};
</script>
<style scoped>
.header-actions-wrapper {
  display: flex;
  flex-direction: row;
  width: 100%;
  > * {
    flex-grow: 1;
  }
}
.additional-header-actions .btn {
  font-size: 13px;
}
</style>
